import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui/button';
import { useToast } from './Toast';
import { t } from '../../i18n';

/**
 * Bridges the generated service worker's update lifecycle into the UI.
 * `registerType: 'prompt'` (see vite.config.ts) means a new version never
 * takes over silently — a coach mid-programme shouldn't have the app (and
 * the figure catalogue it's built on) swapped out from under them. This
 * renders nothing until there's actually a new version waiting.
 */
export function UpdatePrompt() {
  const toast = useToast();
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (!offlineReady) return;
    toast(t('pwa.offlineReady'));
    setOfflineReady(false);
  }, [offlineReady, setOfflineReady, toast]);

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-[calc(var(--nav-h)+14px)] z-80 mx-auto flex max-w-sm items-center justify-between gap-3 rounded-xl border border-border bg-card px-4 py-3 text-card-foreground shadow-lg"
    >
      <span className="text-sm font-medium">{t('pwa.updateAvailable')}</span>
      <Button
        size="sm"
        onClick={() => {
          setNeedRefresh(false);
          void updateServiceWorker(true);
        }}
      >
        {t('pwa.reload')}
      </Button>
    </div>
  );
}
